export const getProperty = (store) => store.property;

export const getPropertyUsers = (store) => (getProperty(store) ? getProperty(store).users : []);
